import { validateForm } from '@zk/framework-vue';
import { addResizeListener, removeResizeListener } from 'zk-ui';
import { getSprintByProject } from '@/api/sprint';
import { getBurnupProjectSprintInfo } from '@/api/home';
import { mapState } from 'vuex';
import { getProjectsFeatureSwitches } from '../../../api/project';
import { getRecommendSetting, getRecommendInfo } from '@/api/widget';
import { isArray, omit, debounce, merge } from 'lodash';
import Vue from 'vue';

export const shareData = Vue.observable({
  projectList: []
});
let isLoadingProjectList = false;

export const loadProjectList = async (list)=> {
  if (!isLoadingProjectList) {
    isLoadingProjectList = true;
    try {
      // const projectList = getProjectList(list);
      const projectList = list;
      // console.log(55555555, list, projectList);
      const res = await getProjectsFeatureSwitches(projectList.map(project => project.id));
      if (isArray(res)) {
        shareData.projectList = projectList.map(project => ({
          ...project,
          features: omit(res.find(feature => feature.projectId === project.id) || {}, 'projectId')
        }));
      } else {
        shareData.projectList = projectList.map(project => ({ ...project, features: {} }));
      }
    } finally {
      isLoadingProjectList = false;
    }
  }
};

// const getProjectList = function (projectList) {
//   let list = [];
//   if (projectList) {
//     list = projectList.filter(item => !item.archived);
//   }
//   return list;
// };

export default {
  props: {
    settingsJson: {
      type: String,
      default: null
    },
    isCopy: {
      type: Boolean,
      default: false
    },
    isEdit:{
      type: Boolean,
      default: false
    },
    silentMode:{
      type: Boolean,
      default: false
    },
    availableWidgetId: {
      type: Number,
      default: null
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isRecommend: {
      type: Boolean,
      default: false
    },
    titleMaxLength: {
      type: Number,
      default: 20
    },
    widgetName: {
      type:String,
      default: ''
    },
    addWidgetTemplateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      settings: {
        title: null,
        projectId: null
      },
      sprintLoading: false,
      sprintList: [],
      projectSprintList:null,
      isSaveConfig: false, // 预览时的请求flag
      // eslint-disable-next-line spellcheck/spell-checker
      recomendList: [],
      submitEmitDebounce: debounce(() => this.submitEmit(), 1000),
      activeRecommend: null
    };
  },
  computed: {
    ...mapState({
      storeProjectList: state => state.app.projectList
    }),
    projectList() {
      return shareData.projectList.filter(item => !item.archived);
    },
    allProjectList() {
      return shareData.projectList;
    },
    rules() {
      return {
        title: [
          { required: true, message: this.$t('home.widgetForm.placeholder.title'), trigger: 'blur' },
          { max: this.titleMaxLength, message: this.$t('home.widgetForm.placeholder.titleLimit'), trigger: 'change' }
        ],
        projectId: [
          { required: true, type: 'number', message: this.$t('home.widgetForm.placeholder.project'), trigger: 'change' }
        ]
      };
    },
    haveSprint() {
      return Reflect.has(this.settings, 'sprintId') || Reflect.has(this.settings, 'sprintIds');
    },
    sprintCycle() {
      if (!this.haveSprint) {
        return null;
      }
      const sprint = this.sprintList.find(s => s.id === this.settings.sprintId);
      if (!sprint) {
        return null;
      }
      const { startDate, endDate } = sprint;
      if (!startDate || !endDate) {
        return '-';
      }
      return `${this.$options.filters.formatDate(startDate)} - ${this.$options.filters.formatDate(endDate)}`;
    },
    currentProject(){
      return this.projectList.find(project=> project.id === this.settings.projectId);
    },
    hasEpicFeature(){
      return this.currentProject?.features?.module_epic_switch;
    },
    // eslint-disable-next-line spellcheck/spell-checker
    recomendListDisabled(){
      // eslint-disable-next-line spellcheck/spell-checker
      return this.recomendList.map(ele=>{

        if (ele?.requirement?.module_epic_switch && !this.hasEpicFeature){
          ele.disabled = true;
        } else {
          ele.disabled = false;
        }
        return { ...ele };
      });
    },
    configNameInputOption(){
      return {
        type: this.titleMaxLength > this.$inputMaxLength ? 'textarea' : 'text'
      };
    }
  },
  watch: {
    settingsJson: {
      immediate: true,
      handler(n, o) {
        if (n !== o) {
          this.parseSettings(n);
        }
      }
    },
    settings: {
      deep: true,
      handler(newValue, oldValue) {
        // 对象newvalue 和oldvalue一样
        // 引用类型地址无改变就不变，
        if (newValue === oldValue) {
          this.isSaveConfig && this.submitEmitDebounce();

        }
      }
    }
  },
  async created() {
    if (this.haveSprint) {
      this.$watch('settings.projectId', this.onProjectChange, { immediate: true });
    }
    this.eventBus.$on('project-create', this.reloadProjects);
    await this.loadProjectList(this.storeProjectList);
    this.isRecommend && this.getDefaultRecommend();

  },
  mounted() {
    addResizeListener(this.$el, this.onResize);
    if (!this.settings.title) {
      this.focusField('title');
    }
    if (this.isCopy) {
      this.selectField('title');
    }
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.onResize);
    this.eventBus.$off('project-create', this.reloadProjects);
  },
  methods: {
    handleToggle(){
      this.settings = { ...this.settings, showRecommendContent: !this.settings.showRecommendContent };
      this.submitEmit();
    },
    reloadProjects() {
      shareData.projectList = [];
      isLoadingProjectList = false;
      this.loadProjectList(this.storeProjectList);
    },
    onResize() {
      const rect = this.$el.getBoundingClientRect();
      this.$emit('resize', rect);
    },
    updateConfigSettings(settings) {
      this.settings = Object.assign(this.settings, settings);
    },
    parseSettings(value) {
      const settings = value ? JSON.parse(value) : {};
      this.settings = { ...this.settings, ...settings };
    },
    async onProjectChange(projectId) {
      if (projectId) {
        this.sprintLoading = true;
        let res = [];

        if (['BugWidgetConfig', 'BugWidget', 'ChartWidget', 'ChartWidgetConfig'].includes(this.$options.name)) {
          res = await this.$store.dispatch('sprint/getProjectSprintList', projectId) || [];
          this.projectSprintList = res;
          // eslint-disable-next-line spellcheck/spell-checker
        } else if (['BurnupWidget', 'BurnupWidgetConfig', 'BurndownWidget', 'BurndownWidgetConfig'].includes(this.$options.name)) {
          const result = await getBurnupProjectSprintInfo({
            burnType: 1,
            projectId
          });
          res = result.sprintVOS || [];
          this.projectSprintList = res;
        } else {
          res = await getSprintByProject(projectId) || [];
          this.projectSprintList = res;
        }
        this.sprintList = res.map(item => ({
          ...item,
          label: item.name,
          value: item.id
        }));
        this.sprintLoading = false;
      } else {
        this.sprintList = [];
      }
      const have = this.sprintList.some(s => s.id === this.settings.sprintId);
      // eslint-disable-next-line spellcheck/spell-checker
      if (!have && !['BurnupWidget', 'BurnupWidgetConfig', 'BurndownWidget', 'BurndownWidgetConfig'].includes(this.$options.name)) {
        this.settings.sprintId = null;
      }
      if (!this.unFilterSprintIds){
        this.settings.sprintIds = this.settings.sprintIds?.filter(id => this.sprintList.find(item => item.id === id)) || [];
      } else {
        this.settings.sprintIds = this.settings.sprintIds?.filter(id => this.statisSprintList.find(item => item.id === id)) || [];
      }
      this.reloadedSprint();
    },
    async reloadSprint(){
      await this.onProjectChange(this.settings.projectId);
      if (['CumulativeFlowDiagramConfig'].includes(this.$options.name)){
        this.setSprintName(this.settings.sprintIds);
      }
    },
    reloadedSprint() { },
    getFieldComponent(prop) {
      return this.$refs.form?.fields.find(field => field.prop === prop);
    },
    selectField(prop) {
      const field = this.getFieldComponent(prop);
      if (field) {
        const input = field.$slots.default?.[0]?.componentInstance;
        input && input.select();
      }
    },
    syncData(data, key) {
      this[key] = data;
    },
    focusField(prop) {
      const field = this.getFieldComponent(prop);
      if (field) {
        const input = field.$slots.default?.[0]?.componentInstance;
        input && input.focus();
      }
    },
    loadProjectList:loadProjectList,
    async getSettings(isUserClick) {
      if (isUserClick){
        await validateForm(this.$refs.form);
      }
      if (this.addWidgetTemplateId) {
        const value = await this.getRecommendInfoRequest(this.addWidgetTemplateId, true);
        this.settings = merge({}, this.settings, value);
      }
      return {
        ...this.settings
      };
    },
    async getEpic(defaultProject){
      await this.getDefaultRecommend();
      // eslint-disable-next-line spellcheck/spell-checker
      const templateInfo = this.recomendList.find(item => item.id === this.addWidgetTemplateId);
      defaultProject = this.projectList?.find(item=> item.id === defaultProject.id);
      if (!(templateInfo?.requirement?.module_epic_switch)) {
        this.settings.projectId = defaultProject?.id || this.settings.projectId;
        return defaultProject;
      }
      if (defaultProject.features.module_epic_switch) {
        this.settings.projectId = defaultProject?.id || this.settings.projectId;
        return defaultProject;
      }
      const expectProject = this.projectList.find(project=> project.features.module_epic_switch);
      this.settings.projectId = expectProject.id;
      return expectProject;

    },
    async getDefaultRecommend() {
      if (this.availableWidgetId) {
        // eslint-disable-next-line spellcheck/spell-checker
        this.recomendList = await getRecommendSetting({ id: this.availableWidgetId });

      }

    },
    async getRecommendInfoRequest(value, onlyGetResult) {
      this.activeRecommend = value;
      const params = {
        projectId: this.settings.projectId,
        settingId: value?.id || value
      };
      const res = await getRecommendInfo(params);
      if (onlyGetResult) {
        return res;
      }
      this.currentRecommendInfo = {
        name: value.templateName,
        settings: res
      },
      // eslint-disable-next-line spellcheck/spell-checker
      this.setRecomend(res);
      this.$message.success(this.$t('home.dashboard.setSuccess', { recommend: res.title }));

    },
    // eslint-disable-next-line spellcheck/spell-checker
    setRecomend(value) {
      this.settings = merge({}, this.settings, value);
      this.submitEmitDebounce();
    },
    submitEmit() {
      this.isSaveConfig && this.$emit('submit');
    }
  }
};
